import { Button, Checkbox, ListItem, ListItemText } from '@mui/material'
import { Box, Stack } from '@mui/system'
import { useState } from 'react'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { useTranslation } from 'react-i18next'
import { makeStyles } from "@mui/styles";
import { useNavigate } from 'react-router-dom'
import { useIsMobile } from '@/hooks/useSizeBreakpoints'

export type ChildStepProps = {
  mainKey: string
  // The label of the child step
  label: string
  // The checked status of the child step
  checked: boolean
  // The optional function to redirect to another page
  redirect?: () => string
  // The optional function to show the user information
  showUser?: () => void
}

const useStyles = makeStyles((theme) => ({
  checkedIcon: {
    "& .MuiSvgIcon-root": {
      color: "green",
    },
  },
  uncheckedIcon: {
    "& .MuiSvgIcon-root": {
      color: "gray",
    },
  },
}));

export function ChildStep(props: ChildStepProps) {
  const [isHovered, setIsHovered] = useState(false)
  const { t } = useTranslation()
  const classes = useStyles();
  const checkboxClass = props.checked ? classes.checkedIcon : classes.uncheckedIcon;
  const navigate = useNavigate()
  const isTooSmall = useIsMobile()

  return (
    <ListItem
      sx={{
        padding: '10px',
        transition: 'background-color 0.3s ease',
        backgroundColor: isHovered ? 'rgba(0, 0, 0, 0.05)' : 'transparent',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      disableGutters
      alignItems="center"
    >
      <Checkbox className={checkboxClass}
        sx={{ padding: '0 10px 0 0', color: 'green' }} checked={props.checked} icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} />
      <ListItemText primary={t(`page.onboarding.steps.${props.mainKey}.childSteps.${props.label}.label`)} />

      <Box sx={{ visibility: isHovered ? 'visible' : 'hidden', ml: 'auto' }}>
        <Stack direction={isTooSmall ? "column" : "row"} spacing={2} justifyContent="center">
          {props.showUser && (
            <Button variant="contained" onClick={() => props.showUser && navigate('/' + props.showUser())}>
              {t('page.onboarding.tutorial.showMe')}
            </Button>
          )}
          {props.redirect && (
            <Button variant="outlined" onClick={() => props.redirect && navigate('/' + props.redirect())}>
              {t('page.onboarding.tutorial.goTo')}
            </Button>
          )}

        </Stack>
      </Box>
    </ListItem>
  );
}
